import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from "../../../../environments/environment"
import { LoginService } from '../../services/login/login.service';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { HomeComponent } from '../home/home.component';
import { MapService } from 'src/app/view/services/map.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import WebMap from "@arcgis/core/WebMap";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  @ViewChild('sidenav') sidenav: MatSidenav;

  projectEnvironment = environment;
  project: string = environment.project;
  version: string = environment.version;
  documentationUrl: string = environment.documentationUrl;
  potActivated: boolean = false
  facActivated: boolean = false

  constructor(
    protected dialog: MatDialog,
    public loginService: LoginService,
    public homeComponent: HomeComponent,
    public mapService: MapService,
    private _snackBar: MatSnackBar
  ) {
  }

  toggle() {
    this.sidenav.toggle();
    this.homeComponent.sidenavView = !this.homeComponent.sidenavView;
  }

  openUserManual() {
    window.open(this.documentationUrl, "_blank");
  }

  reload() {
    window.location.reload();
  }

  openSettingsLayer() {
    this.dialog.open(ModalWindowComponent, { autoFocus: false });
  }

  displayInitial360Message() {
    if (!this.mapService.currentScene) {
      this._snackBar.open("Seleccione un marcador en el mapa para activar la vista 360", " cerrar", {
        duration: 7000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: 'custom-panel'
      });
    }
  }

  toggle360View() {
    if (this.homeComponent.activatedViewPanoramic) {
      this.homeComponent.changeViewMap();
    } else {
      this.displayInitial360Message()
      this.homeComponent.changeViewMixed();
    }
    this.toggle();
  }

  viewDashboard() {
    if (this.homeComponent.activatedViewMap) {
      this.homeComponent.activatedViewMap = false;
      this.homeComponent.activatedViewPanoramic = false;
      this.homeComponent.activatedViewDashboard = true;
    } else {
      this.homeComponent.activatedViewMap = true;
      this.homeComponent.activatedViewPanoramic = false;
      this.homeComponent.activatedViewDashboard = false;
    }
    this.toggle();
  }

  viewMapPot() {

    let webMapActual = this.mapService.getViewMap().map as WebMap;
    const webMapIni = new WebMap({                        // Define the web map
      portalItem: {
        id: this.projectEnvironment.mapId
      }
    });

    const webMapPot = new WebMap({                        // Define the web map pot
      portalItem: {
        id: this.projectEnvironment.mapIdPot,
      }
    });

    if (webMapActual.portalItem.id === this.projectEnvironment.mapIdPot) {
      this.mapService.getViewMap().map = webMapIni;
      this.potActivated = !this.potActivated
    } else {
      this.mapService.getViewMap().map = webMapPot;
      this.potActivated = !this.potActivated
      
    }
    this.homeComponent.changeViewMap();
  }
  viewMapFact() {

    let webMapActual = this.mapService.getViewMap().map as WebMap;
    const webMapIni = new WebMap({                        // Define the web map
      portalItem: {
        id: this.projectEnvironment.mapId
      }
    });

    const webMapFact = new WebMap({                        // Define the web map fac
      portalItem: {
        id: this.projectEnvironment.mapIdfact,
      }
    });

    if (webMapActual.portalItem.id === this.projectEnvironment.mapIdfact) {
      this.mapService.getViewMap().map = webMapIni;
      this.facActivated = !this.facActivated
    } else {
      this.mapService.getViewMap().map = webMapFact;
      this.facActivated = !this.facActivated
      
    }
    this.homeComponent.changeViewMap();
  }
}
